import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchAllContent, getContentWithFallback, seedContent } from "../data/api";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      try {
        // Seed first, then fetch
        await seedContent().catch(() => {});
        const data = await fetchAllContent();
        setContent(data);
      } catch (e) {
        console.warn("Using mock data fallback");
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  const getSection = (section) => getContentWithFallback(content, section);

  return (
    <ContentContext.Provider value={{ content, loading, getSection }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent must be used within ContentProvider");
  return ctx;
};
